import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import crossFetch from 'cross-fetch';

var _excluded = ["below"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Fetches Fortum Indiana menu items from given JSON URL
 *
 * @param dataURL - JSON URL to fetch from
 * @param setRetryTimeout - Callback which receives retryTimeout when set
 * @param initialRetryBackoff - Initial retry backoff value in milliseconds
 */
var fetchMenuItems = function fetchMenuItems(dataURL, setRetryTimeout, abortController, fetchFn) {
  var initialRetryBackoff = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 200;
  var retryBackoff = initialRetryBackoff;
  var _doFetch = function doFetch() {
    return fetchFn(dataURL, {
      signal: abortController.signal
    }).then(function (res) {
      return res.json();
    }).then(function (json) {
      return json.filter(function (item) {
        return item.enabled;
      }).map(function (item) {
        // Refactor the API response's item.below from a map of MenuItems to
        // an array of MenuItems
        var below = item.below,
          rest = _objectWithoutProperties(item, _excluded);
        var menuItem = _objectSpread({}, rest);
        if (below) {
          menuItem.below = Object.keys(below).map(function (belowItemKey) {
            return below[belowItemKey];
          });
        }
        return menuItem;
      });
    })["catch"](function (e) {
      if (e.name === 'AbortError') return Promise.resolve(); // expected, this is the abort, so just return

      return new Promise(function (resolve) {
        setRetryTimeout(window.setTimeout(resolve, retryBackoff));
      }).then(function () {
        // Double next retryBackoff, though don't exceed 10s
        retryBackoff = Math.min(retryBackoff * 2, 10000);
        return _doFetch();
      });
    });
  };
  return _doFetch();
};
var useMenuApi = function useMenuApi(url, dataProp) {
  var _React$useState = React.useState(dataProp || []),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    data = _React$useState2[0],
    setData = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  var abortController = new AbortController();
  var retryTimeout = null;
  React.useEffect(function () {
    if (dataProp) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchMenuItems(url, function (newRetryTimeout) {
      return retryTimeout = newRetryTimeout;
    }, abortController, crossFetch).then(function (data) {
      if (!data) {
        return;
      }
      setData(data);
      setLoading(false);
    });
    return function () {
      abortController.abort();
      if (retryTimeout !== null) {
        clearTimeout(retryTimeout);
      }
    };
  }, [url, dataProp]);
  return {
    data: data,
    loading: loading
  };
};

export { fetchMenuItems, useMenuApi };
